import { AttackSurfaceReductionPotentialWebComponent } from './component/AttackSurfaceReductionPotentialWebComponent';

export { AttackSurfaceReductionPotentialWebComponent };
